module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a7jtS"))).then(() => parcelRequire('d0iPb'));